import Vue from 'vue'

const defaultState = () => {
  return {
    list: [],
    professionalByInstitutionId: {},
    stateProfessionalByInstitutionId: {},
    availableTherapiesByInstitutionId: {},
    clientConfigsByIntitutionId: {},
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getters: {
    currentInstitutionId: (state, getters, rootState, rootGetters) => {
      return rootGetters['patient/getPatient']?.institution_id || null
    },
    currentInstitutionName: (state, getters) => {
      const activeInstitution = state.list.find(({ institution_id: institutionId }) => institutionId === getters.currentInstitutionId)

      return activeInstitution?.institution_name || ''
    },
    currentInstitutionCustomConfigs: (state, getters) => {
      const activeInstitution = state.list.find(({ institution_id: institutionId }) => institutionId === getters.currentInstitutionId)

      return activeInstitution?.custom_configs || {}
    },
    currentInstitutionConfigs: (state, getters) => {
      const activeInstitution = state.list.find(({ institution_id: institutionId }) => institutionId === getters.currentInstitutionId)

      const institutionConfigs = Object.values(activeInstitution?.ecosystem_configs || {}).reduce((acc, { key, value }) => {
        return { ...acc, [key]: value }
      }, {})

      return {
        swordGoEnabled: Boolean(Number(institutionConfigs.sword_go_enabled)),
        disablePrescriptionJustification: Boolean(Number(institutionConfigs.disable_prescription_justification)),
      }
    },
    currentInstitutionClientConfigs: (state, getters) => {
      return state.clientConfigsByIntitutionId[getters.currentInstitutionId] || {}
    },
    userInstitutionsList: (state) => state.list,
    getInstitutionById: (state) => (id) => state.list.find((i) => i.institution_id === id),
    getCurrentInstitutionProfessionals: (state, getters) => {
      const institutionId = getters.currentInstitutionId

      return institutionId ? state.professionalByInstitutionId[institutionId] : undefined
    },
    getCurrentInstitutionStateProfessionals: (state, getters) => {
      const institutionId = getters.currentInstitutionId

      return institutionId ? state.stateProfessionalByInstitutionId[institutionId] : undefined
    },
  },
  mutations: {
    setInstitutions(state, institutionsList) {
      state.list = institutionsList
    },
    setInstitutionProfessionals(state, { institutionId, professionals }) {
      Vue.set(state.professionalByInstitutionId, institutionId, professionals)
    },
    setInstitutionStateProfessionals(state, { institutionId, stateProfessionals }) {
      Vue.set(state.stateProfessionalByInstitutionId, institutionId, stateProfessionals)
    },
    setInstitutionTherapies(state, {
      institutionId, therapies,
    }) {
      Vue.set(state.availableTherapiesByInstitutionId, institutionId, therapies)
    },
    setInstitutionClientConfigs(state, { institutionId, configs }) {
      Vue.set(state.clientConfigsByIntitutionId, institutionId, configs)
    },
    resetInstitutions(state) {
      const rawState = defaultState()

      Object.entries(rawState).forEach(([prop, value]) => {
        Vue.set(state, prop, value)
      })
    },
  },
  actions: {
    checkInstitutionChange({ getters, commit }, previousInstitutionId) {
      const currentInstitutionId = getters.currentInstitutionId

      // It's ok. Same institution
      if (previousInstitutionId === currentInstitutionId) {
        console.log('[institution-change] Same institution - OK')

        return
      }

      // Oh! A goose! This is not a valid institution for this professional
      if (!getters.getInstitutionById(currentInstitutionId)) {
        // eslint-disable-next-line no-alert
        alert('User does not have access to current member institution')

        return
      }

      // Clear institution specific cached data
      commit('prescription/therapies/setInstitutionTherapies', [], { root: true })
    },
    async fetchInstitutionTherapiesByInstitutionID({ getters, commit }) {
      const institutionIdToUse = getters.currentInstitutionId

      try {
        const { data } = await Vue.$http('institutions/clinical/fetchTherapiesByInstitutionID', institutionIdToUse)
        const therapiesForInstitutionId = {
          institutionId: institutionIdToUse,
          therapies: data.therapies,
        }

        commit('setInstitutionTherapies', therapiesForInstitutionId)
        commit('prescription/therapies/setInstitutionTherapies', therapiesForInstitutionId.therapies, { root: true })
      } catch (e) {
        console.log(`Error getting institution(ID:${institutionIdToUse}) therapies .`, e)
      }
    },
    async fetchActiveInstitutionClientData({ commit, getters }) {
      try {
        const institutionId = getters.currentInstitutionId

        if (!institutionId) {
          return Promise.reject()
        }

        const { data: institutionData } = await Vue.$http('institutions/fetchInstitutionDetails', institutionId)
        const { data: clientData } = await Vue.$http('institutions/fetchInstitutionClientData', institutionData.data.unique_key)
        const { client } = clientData
        const { configuration: configs } = client

        commit('setInstitutionClientConfigs', { institutionId, configs })

        return Promise.resolve(client)
      } catch (error) {
        console.log(error)

        return Promise.reject(error)
      }
    },
    setProfessionalByInstitutionId({ commit }, { institutionId, professionalsData }) {
      const { professionals, state_professionals: stateProfessionals } = professionalsData

      commit('setInstitutionProfessionals', { institutionId, professionals })
      commit('setInstitutionStateProfessionals', { institutionId, stateProfessionals })
    },
  },

}
